import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles/globals.css';
import App from './App';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import SmsOptIn from './pages/SmsOptIn';

const router = createBrowserRouter([
	{ path: '/', element: <App /> },
	{ path: '/sms', element: <SmsOptIn /> },
	{ path: '/privacy', element: <Privacy /> },
	{ path: '/terms', element: <Terms /> },
]);

createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
